module.exports = __webpack_public_path__ + "static/media/15.Belt Sander.39de0b54.jpg";